import {
  MODULE_SURGICALLOGS,
  MODULE_POLICIES,
  MODULE_STANDARDS,
  MODULE_TRACKING,
  MODULE_DOCUMENTS,
} from '@surglogs-app/auth'

export const messages = {
  features: {
    [MODULE_SURGICALLOGS]: {
      headline:
        'Worried about <highlight>missing accreditation checks or evidence?</highlight>',
      list: [
        'Life Safety',
        'Fire Safety',
        'Infection Control',
        'Temperature and Humidity',
        'Accreditation Checks',
        'Medications and Supplies',
        'And More',
      ],
    },
    [MODULE_TRACKING]: {
      headline:
        '<highlight>Missing sterilization or incident reporting records?</highlight> Find them quickly in Surglogs',
      list: [
        'Sterile Processing Records',
        'Instrument Tracking',
        'Incident Reporting',
        'Implant Tracking',
        'Tissues Tracking',
        'Call Back Logs',
        'And More',
      ],
    },
    [MODULE_DOCUMENTS]: {
      headline:
        'Need reminders when <highlight>important documents are up for renewal?</highlight>',
      list: [
        'Staff Licensure',
        'Vendor Contract Management',
        'Credentialing',
        'Critical Facility Documents',
        'And More',
      ],
    },
    [MODULE_STANDARDS]: {
      headline:
        'Are you up-to-date with the <highlight>latest standards from your accrediting body?</highlight>',
      list: [
        'The Joint Commission',
        'QUAD A',
        'AAAHC',
        'OSHA',
        'NFPA',
        'HHS',
        'And More',
      ],
    },
    [MODULE_POLICIES]: {
      header: {
        headline: 'Explore Our <highlight>Policy Templates</highlight>',
        content:
          'Access a comprehensive set of policies that are already linked to the corresponding standards. <b>Let Surglogs do your crosswalk for you.</b>',
      },
      headline:
        'Is managing policies & procedures <highlight>difficult and time-consuming?</highlight>',
      list: [
        'Policy Management',
        'Approval Process',
        'Automatic Policy Generation with Connection to the Standard',
        'Employee Signing',
        'And More',
      ],
    },
    FILLABLE_DOCUMENTS: {
      headline:
        'Are you struggling to keep track of competencies? <highlight>Try Fillable Documents</highlight>',
      list: [
        'Competencies',
        'Onboarding',
        'Surveys',
        'Declination forms',
        'Job descriptions',
        'Employment info',
        'And More',
      ],
    },
    COMPETENCIES: {
      headline: 'Ensure Compliance & Elevate Staff Competency with Surglogs',
      list: [
        'Track Staff Competencies in One Place',
        'Customizable & Scalable',
        'Streamline Compliance Audits',
        'Automate Reminders & Expirations',
        'And More',
      ],
    },
    SURVEY_READINESS_C: {
      headline: '',
      list: [],
    },
    SURVEY_READINESS_B: {
      headline:
        "<highlight>Stop guessing what surveyors want</highlight> - Surglogs' Survey Readiness, built with consultants, shows you every task your center needs to stay compliant, step by step.",
      list: [
        'Compliance guide with actionable tasks',
        'Crosswalk',
        'Compliance gap reports',
        'Centralized tasks management',
        'Unified search through the platform',
      ],
    },
    SURVEY_READINESS_A: {
      headline:
        "<highlight>Don't Wait for a Surveyor to Find Your Deficiencies</highlight> - Surglogs' Survey Readiness, built with consultants, shows you every task your center needs to stay compliant, step by step.",

      list: [
        'Compliance guide with actionable tasks',
        'Crosswalk',
        'Compliance gap reports',
        'Centralized tasks management',
        'Unified search through the platform',
      ],
    },
    // just for typescript
    LOGIN_PROMO_VIDEO: {
      headline: '',
      list: [],
    },
  },
  trialRequestDisabled: 'You can not submit trial request from this clinic',
  sendRequest: 'Send request',
  confirm:
    '<b>Want to learn more?</b> Please, confirm this is your email address and we will contact you shortly.',
  confirmInDevelopment: `<b>Want to try it yourself?</b> Enter your email address below.`,
  emailInputPlaceholder: 'Your business email',
  successMessage: {
    title: 'Request Sent',
    text: 'Request has been sent successfully.',
  },
  newFeature: 'New Feature',
  video: {
    unsupportedMessage:
      "It looks like your browser doesn't support embedded videos. Please try using a different browser to view this content.",
  },
} as const
